import { render, staticRenderFns } from "./details_avenir.vue?vue&type=template&id=0c2c2317"
import script from "./details_avenir.vue?vue&type=script&lang=js"
export * from "./details_avenir.vue?vue&type=script&lang=js"
import style0 from "./details_avenir.vue?vue&type=style&index=0&id=0c2c2317&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports